
<template>
  <div id="extra-component-chartist-demo">
    <div class="p-3 pt-2">
      <div class="mb-4 userStats p-5">
        <vs-row vs-justify="space-between">
          <div class="m-4 fontS20 ml-6 pl-1">Total Users</div>
          <div class="m-4 fontS20 mr-6 pr-4">
            {{
              details.startM +
              " " +
              details.startY +
              " - " +
              details.endM +
              " " +
              details.endY
            }}
          </div>
        </vs-row>
        <div>
          <vue-apex-charts
            type="area"
            height="350"
            width="99%"
            :options="chart.chartOptions"
            :series="chart.series"
            v-if="key"
          ></vue-apex-charts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  data() {
    return {
      genericErrorMessage,
      toast,

      key: false,

      details: {
        startM: "",
        startY: "",
        endM: "",
        endY: "",
      },

      chart: {
        series: [
          {
            name: "users",
            data: [],
          },
        ],
        width: "100%",
        chartOptions: {
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "straight",
          },
          chart: {
            toolbar: {
              show: false,
            },
          },
          xaxis: {
            type: "category",
            categories: [],
            labels: {
              show: true,
              style: {
                colors: [],
                fontSize: "15px",
                fontFamily: "Montserrat",
              },
            },
          },
          yaxis: {
            show: true,
            labels: {
              show: true,
              style: {
                colors: [],
                fontSize: "15px",
                fontFamily: "Montserrat",
              },
              formatter: (value) => {
                return Math.round(value);
              },
            },
            showAlways: true,
            seriesName: "users",
            opposite: false,
            reversed: false,
            logarithmic: false,
            tickAmount: 6,
            min: 0,
            max: 3000,
            forceNiceScale: false,
            floating: false,
            decimalsInFloat: undefined,
          },
          tooltip: {
            x: {
              format: "dd/MM/yy HH:mm",
            },
            y: {
              title: {
                formatter: (seriesName) =>
                  seriesName.charAt(0).toUpperCase() + seriesName.slice(1),
              },
            },
          },
          grid: {
            borderColor: "#111",
            strokeDashArray: 4,
          },
          fill: {
            type: "gradient",
            gradient: {
              type: "vertical",
              shadeIntensity: 1,
              gradientToColors: ["#2E5BFF"],
              inverseColors: true,
              opacityFrom: 0.5,
              opacityTo: 0,
              stops: [0, 90, 100],
              colorStops: [],
            },
          },
          markers: {
            size: [5],
            colors: "#FFF",
            strokeColors: "#4B4BF9",
            strokeWidth: 2,
            strokeOpacity: 1,
            fillOpacity: 1,
            discrete: [],
            shape: "circle",
            radius: 2,
            offsetX: 0,
            offsetY: 0,
            onClick: undefined,
            onDblClick: undefined,
            hover: {
              size: undefined,
              sizeOffset: 3,
            },
          },
        },
      },
    };
  },
  methods: {
    async getDetails() {
      return new Promise(async () => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.DashboardGraph)
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              this.chart.series = [
                {
                  name: "users",
                  data: res.data.data.usersCount,
                },
              ];
              this.chart.chartOptions.yaxis.max = await Math.max(
                ...res.data.data.usersCount
              );
              this.chart.chartOptions.xaxis.categories =
                res.data.data.monthsLabel;

              this.details = {
                startM: res.data.data.details.startMonth,
                startY: res.data.data.details.startYear,
                endM: res.data.data.details.endMonth,
                endY: res.data.data.details.endYear,
              };
              this.$emit("update-details", {
                totalAccounts: res.data.data.details.totalAccounts,
                newAccounts: res.data.data.details.newAccounts,
                totalProfiles: res.data.data.details.totalProfiles,
                newProfiles: res.data.data.details.newProfiles,
                newMessages: res.data.data.details.newMessages,
                pendingCards: res.data.data.details.pendingCards,
                topIssuers: res.data.data.details.topIssuers,
                topcards: res.data.data.details.topcards,
                userAddedPromoCount: res.data.data.details.userAddedPromoCount,
                usersWithCardsAdded:res.data.data.details.usersWithCardsAdded,
                usersWithNoCardsAdded:res.data.data.details.usersWithNoCardsAdded,
              });
              this.key = true;
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
            // console.log('Error in getting graph details: ',e);
          });
      });
    },
  },
  created() {
    this.getDetails();
    this.$vs.loading({
      background: "rgba(1,2,3,.2)",
    });
  },
  components: {
    VueApexCharts,
  },
};
</script>

<style>
.fontS20 {
  font-size: 20px;
  font-weight: bold;
}
.userStats {
  background-color: #1d2024 !important;
  border-radius: 10px;
}
</style>
